import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import { ProducaoService } from '../../../shared/services/api/ProducaoService';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AutoCompleteColhedor1 } from '../../../shared/forms/AutoCompleteColhedor1';

export const GeraProducaoIndividual: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs());
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [guuidcolhedor, SetGuuidcolhedor] = useState('')
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

  const handleDelete = () => {
    setOpenConfirm(true);
  };


  const handleGera = () => {
    ProducaoService
    .GeraProducaoIndividual(guuidcolhedor, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setTms('success');
          setMsg('Produção Gerada com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleConfirmDelete = () => {

    ProducaoService
      .deleteProducaoIndividual(guuidcolhedor, dayjs(dataFinal).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setTms('success');
          setMsg('Produção Excluida com sucesso!');
          setOpenmsg(true);
        }
      });
      setOpenConfirm(false);
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  const handleIdColhedor = (idcolhedor: string | undefined) => {
    if (idcolhedor != null) {
      SetGuuidcolhedor(idcolhedor);
    }
  }; 
  
  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
                Nâo
              </Button>
            </>
          }
        >
          Tem certeza que deseja excluir Produção?
        </Alert>
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' margin={1} alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Gera Produção Individual</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
              <AutoCompleteColhedor1
                isExternalLoading={isLoading}
                idcolhedor={handleIdColhedor}
              /> 
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                   sx={{ marginTop:2, width:150 }}  
                  format='DD/MM/YYYY'
                  value={dataInicial}
                  onChange={(newValue) => setDataInicial(newValue)}
                  label='Data Inicial'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider 
                dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{marginTop:2,  marginLeft:2, width:150 }}  
                  format='DD/MM/YYYY'
                  value={dataFinal}
                  onChange={(newValue) => setDataFinal(newValue)}
                  label='Data Final'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>

        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='error' autoFocus onClick={handleDelete}>Excluir Produção</Button>
          <Button variant='contained' autoFocus onClick={handleGera}>Gera Produção</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   